export enum Segment {
    VIP = 'VIP',
    NEW = 'NEW',
    OK = 'OK',
    LOW = 'LOW'
}